/**
 * TransitionPreviewBackground renders the first frame of the preview clip 1 as a background
 * to prevent white background flashing when the preview starts.
 */

import { Img } from "remotion";

const PREVIEW_BACKGROUND_IMAGE = "/transitions/CLIP_1.jpg";

export default function TransitionPreviewBackground() {
  return (
    <Img
      src={PREVIEW_BACKGROUND_IMAGE}
      className="h-full w-full object-cover object-center"
    />
  );
}
